import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
export const assertBadHttpStatus = response => {
  if (response.statusCode === 200) {
    return;
  }
  throw new HttpBadStatusCodeError({
    domain: 'src/services/assert/assertBadHttpStatus',
    message: 'Layouts HttpBadStatusCodeError',
    statusCode: response.statusCode
  });
};